import { createGlobalStyle } from 'styled-components';

export const ThemeGlobalStyle = createGlobalStyle`
  body {
    --transition: 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  
    /*
     * Colors
     */
  
    --color-black: #000000;
    --color-white: #ffffff;
    --color-fog: #fbfbfb;
  
    /* site background */
    --color-platinum: #f8f6f6;
  
    /* header search background */
    --color-lightGrey: #f4f5f5;
    --color-offWhite: #f1f1f1;
    --color-aluminum: #e6e6e6;
  
    /* some dividers */
    --color-silver: #c4c8cc;
    --color-coolGrey: #b0b4b9;
    --color-middleGrey: #787878;
    --color-battleshipGrey: #717375;
    --color-greyishBrown: #484848;
    --color-charcoalGrey: #242424;
    --color-waterBlue: #0d73d9;
    --color-niceBlue: #0f5cb5;
    --color-turtleGreen: #68bd53;
    --color-marigold: #f7c702;
    --color-scarlet: #d0021b;
    --color-lightRed: #ffcece;
  
    /* secondary colors */
    --color-steelGrey: #6f6f6f;
    --color-mediumNavy: #00408a;
    --color-hoverBlue: #0042C1;

    /* accessible waterBlue for light grey backgrounds */
    --color-skyBlue: #1d91e9;
    --color-babyBlue: #5dc2f1;
    --color-lightBlue: #bbeaff;
    --color-softBlue: #ebf6ff;
    --color-lemon: #f7fc26;
    --color-poppy: #ef444d;
    --color-brick: #b40016;
    --color-fuchsia: #a002fd;
    --color-tagLemonGreen: #7de963;
  }
`;
